import Widget from "./Widget";

export default Widget;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Widget/index.js